import { Box, Button, FormControl, IconButton, InputAdornment, OutlinedInput, Stack, Typography } from "@mui/material";
import React, { useEffect } from "react";
import btcImage from "../assets/images/btc.png";
import ethImage from "../assets/images/eth.png";
import usdtethImage from "../assets/images/usdt-erc20.png";
import usdcethImage from "../assets/images/usdc-erc20.png";
import trxImage from "../assets/images/trx.png";
import ltcImage from "../assets/images/ltc.png";
import usdImage from "../assets/images/dollar.png";
import xrpImage from "../assets/images/xrp.png";
import dogeImage from "../assets/images/doge.png";
import { CryptoCurrencies } from "../enums/CryptoCurrenciesCombo";
import { Networks } from "../enums/networks";
import ImportExportIcon from "@mui/icons-material/ImportExport";

const InputAmountMax = ({ setAmount, balance, cryptoCurrency, network, currency, setCurrency, balances, setMaxSet }) => {
	const amountChange = (e) => {
		e.preventDefault();
		setAmount(e.target.value);
		setMaxSet(false);
	};

	const getExchangeByCrypto = () => {
		switch (cryptoCurrency) {
			case CryptoCurrencies.BITCOIN:
				return balances?.exchangeRate?.exchangeRateBTC ?? 0;
			case CryptoCurrencies.ETHEREUM:
				return balances?.exchangeRate?.exchangeRateETH ?? 0;
			case CryptoCurrencies.USDT:
				return balances?.exchangeRate?.exchangeRateUSDT ?? 0;
			case CryptoCurrencies.USDC:
				return balances?.exchangeRate?.exchangeRateUSDC ?? 0;
			case CryptoCurrencies.TRX:
				return balances?.exchangeRate?.exchangeRateTRX ?? 0;
			case CryptoCurrencies.LITECOIN:
				return balances?.exchangeRate?.exchangeRateLTC ?? 0;
			case CryptoCurrencies.DOGECOIN:
				return balances?.exchangeRate?.exchangeRateDOGE ?? 0;
			case CryptoCurrencies.XRP:
				return balances?.exchangeRate?.exchangeRateXRP ?? 0;
			default:
				return 0;
		}
	};

	const setMax = (e) => {
		e.preventDefault();
		var maxAmount = 0;
		let exchangeRate = getExchangeByCrypto();
		if (currency === "USD") {
			maxAmount = parseFloat(parseFloat(balance * exchangeRate).toFixed(2));
		} else {
			maxAmount = balance;
		}
		document.getElementById("txtAmountMax").value = maxAmount;
		setAmount(maxAmount);
		setMaxSet(true);
	};

	const getImageByCryptoNetwork = (cryptoCurrency, network) => {
		if (currency === "USD") {
			return usdImage;
		}
		switch (cryptoCurrency) {
			case CryptoCurrencies.BITCOIN:
				return btcImage;
			case CryptoCurrencies.ETHEREUM:
				return ethImage;
			case CryptoCurrencies.USDT:
				if (network === Networks.ETHEREUM) {
					return usdtethImage;
				} else {
					return usdtethImage;
				}
			case CryptoCurrencies.USDC:
				if (network === Networks.ETHEREUM) {
					return usdcethImage;
				} else {
					return usdcethImage;
				}
			case CryptoCurrencies.TRX:
				return trxImage;
			case CryptoCurrencies.DOGECOIN:
				return dogeImage;
			case CryptoCurrencies.LITECOIN:
				return ltcImage;
			case CryptoCurrencies.XRP:
				return xrpImage;
			default:
				return null;
		}
	};

	useEffect(() => {
		document.getElementById("txtAmountMax").value = "";
	}, [cryptoCurrency]);

	const changeCurrency = (e) => {
		e.preventDefault();
		if (currency === "USD") {
			setCurrency("CRYPTO");
		} else {
			setCurrency("USD");
		}
		setAmount(0);
		document.getElementById("txtAmountMax").value = "";
	};

	return (
		<FormControl sx={{ width: "100%", alignItems: "center", display: "flex" }} fullWidth>
			<Box sx={{ width: "100%", textAlign: "left", marginTop: 2, marginBottom: 1 }}>
				<Typography component="h2" variant="subtitle2" gutterBottom>
					Amount
				</Typography>
				<Stack spacing={2} direction={"row"}>
					<OutlinedInput
						fullWidth
						id="txtAmountMax"
						variant="outlined"
						size="medium"
						onChange={amountChange}
						color="black"
						startAdornment={
							<InputAdornment position="start">
								<Box sx={{ paddingRight: 1 }}>
									<img src={getImageByCryptoNetwork(cryptoCurrency, network)} height={24} width={24} />
								</Box>
								{currency === "USD" ? currency : cryptoCurrency}
							</InputAdornment>
						}
						endAdornment={
							<>
								<IconButton
									sx={{ border: 0 }}
									style={{ backgroundColor: "transparent" }}
									aria-label="Change"
									onClick={changeCurrency}
								>
									<ImportExportIcon />
								</IconButton>
								<Button sx={{ border: 0 }} style={{ backgroundColor: "transparent" }} size="small" onClick={setMax}>
									MAX
								</Button>
							</>
						}
					/>
				</Stack>
			</Box>
		</FormControl>
	);
};

export default InputAmountMax;
